<template>
  <v-app>
    <v-main v-bind:style="stylePagina">
      <v-container  class="mt-lg-6 mt-0 mt-md-6 mt-sm-0" >
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h4">
             DATOS ENVIADOS EXITOSO
            </v-card-title>
              <v-card-subtitle class="text-h5">
                  De ser Aprobado pronto te llegará un mail confirmando tu inscripción.
              </v-card-subtitle>
            <v-card-text>
           {{respuesta}}
             </v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>
          <v-dialog
                  :value="alerterror"
                  persistent
                  max-width="380"
          >
              <v-card>
                  <v-card-title class="text-h5">
                      ERROR
                  </v-card-title>
                  <v-card-text>
                      {{error}}
                  </v-card-text>
              </v-card>

          </v-dialog>
        <v-row   justify="center" align="center">
          <v-col  cols="12" sm="12" lg="5" md="5">
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12" lg="12"  class="text-center" >
                <h1 v-if="logoexist"   class="text-center">
                <center>  <v-img :width="ancho" :src="logoimg" /></center>
                </h1>
                <h1 v-else class="display-1 font-weight-bold">{{titulonegocio}}</h1>
              </v-col>
            </v-row>
          </v-col>
          <v-col  cols="12" sm="12" lg="7" md="7">

            <v-alert
                :value="alertnoacepto"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              {{ errorcon }}
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Tu solicitud fue creada con éxito
            </v-alert>
            <section id="main-cabecera" class="ma-lg-12 ma-md-12 ma-sm-6 ma-2">

              <v-row  >
                <v-col cols="12" sm="12" md="12" lg="12">



                              <v-card>
                                  <v-card-text>
                                      <v-form ref="form1">
                                      <v-row class="pt-6 pr-2 pl-2">
                                          <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <v-text-field prepend-icon="fas fa-at" v-model="editedItem.socioPrincipal.email" @change="damexemail" :label="$t('formularios.Email')" :rules="[rules.required]"></v-text-field>
                                          </v-col>
                              <v-col cols="12" sm="12" md="5" lg="5" xl="5"  class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field prepend-icon="fas fa-id-card" v-model="editedItem.socioPrincipal.dni"  label="DNI O CE" :rules="[rules.required]"></v-text-field>
                              </v-col>

                              <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field prepend-icon="fas fa-user" v-model="editedItem.socioPrincipal.nombre" :label="negociodisenio.labelNombre" :rules="[rules.required]"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field prepend-icon="fas fa-user-alt" v-model="editedItem.socioPrincipal.apellidoPaterno" :label="negociodisenio.labelAppaterno" :rules="[rules.required]"></v-text-field>
                              </v-col>
                              <v-col v-if="negociodisenio.campoapmaterno"  cols="12"  sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field v-if="negociodisenio.campoapmaterno" prepend-icon="fas fa-user-alt" v-model="editedItem.socioPrincipal.apellidoMaterno" :label="negociodisenio.labelApmaterno" :rules="[rules.required]"></v-text-field>
                              </v-col>
                                          <v-col v-if="negociodisenio.campofecnac"   cols="12" sm="12" md="5" lg="5" xl="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <div style="position: relative;"><div style="position: absolute; left:0; right:auto; transform-origin: top left;">Fecha Nacimiento</div>
                                                  <v-row>
                                                      <v-col cols="3"><v-select
                                                              v-model="dia"
                                                              :items="dias"
                                                              @change="changedia"
                                                      >

                                                      </v-select></v-col>
                                                      <v-col cols="4">
                                                          <v-autocomplete
                                                                  v-model="mes"
                                                                  :items="meses"
                                                                  item-text="mes"
                                                                  item-value="fec"
                                                                  @change="changemes"
                                                          >

                                                          </v-autocomplete></v-col>
                                                      <v-col cols="5">
                                                          <v-autocomplete
                                                                  :items="anios"
                                                                  v-model="anio"
                                                                  @change="changeanio"
                                                          >

                                                          </v-autocomplete></v-col>
                                                  </v-row></div>
                                          </v-col>
                                          <v-col v-if="negociodisenio.campotelefono"   cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <v-text-field v-if="negociodisenio.campotelefono"  prepend-icon="fas fa-phone-alt" type="number" v-model="editedItem.socioPrincipal.telefono" :label="$t('formularios.Telefono')" :rules="[rules.required]"></v-text-field>
                                          </v-col>

                                          <v-col  cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <v-text-field   prepend-icon="fab fa-instagram"   v-model="editedItem.socioPrincipal.instagram" label="Instagram" placeholder="Ej: @tunay.app" :rules="[rules.required]"></v-text-field>
                                          </v-col>

                                          <v-col v-if="negociodisenio.camposexo"  cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <v-autocomplete prepend-icon="fas fa-venus-mars" v-if="negociodisenio.camposexo"   v-model="editedItem.socioPrincipal.sexo" :items="sexos"  item-text="sexo" :rules="[rules.required]"  persistent-hint
                                                               return-object
                                                               label="Escoger Sexo"></v-autocomplete>
                                          </v-col>
                                          <v-col v-if="negociodisenio.camporeferido" cols="6" sm="6" md="4">
                                              <v-text-field prepend-icon="fas fa-user-friends" v-if="negociodisenio.camporeferido" v-model="editedItem.referido" :label="$t('formularios.Referido')" :rules="[rules.required]" ></v-text-field>
                                          </v-col>
                                          <v-col v-if="negociodisenio.campocontacto" cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                              <v-autocomplete
                                                      prepend-icon="fas fa-user-friends"
                                                      v-model="editedItem.contacto"
                                                      :items="Contactos"
                                                      item-text="contacto"
                                                      hint="Elija un Contacto" persistent-hint
                                                      return-object
                                                      label="Contacto"></v-autocomplete>
                                          </v-col>

                              <v-col v-if="negociodisenio.campodireccion"  cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-text-field v-if="negociodisenio.campodireccion"  v-model="editedItem.socioPrincipal.direccion" :label="$t('formularios.Direccion')" :rules="[rules.required]"></v-text-field>
                              </v-col>
                              <v-col v-if="negociodisenio.campodistrito"   cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-autocomplete   v-if="negociodisenio.campodistrito"  v-model="editedItem.socioPrincipal.distrito.ciudad.provincia.pais" :items="paises" :rules="[rules.required]"  item-text="pais" persistent-hint
                                                   return-object
                                                   @change="cambiopais"

                                                   label="Pais de Direccion"></v-autocomplete>
                              </v-col>
                              <v-col  v-if="negociodisenio.campodistrito"  cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-autocomplete  v-if="negociodisenio.campodistrito"   v-model="editedItem.socioPrincipal.distrito.ciudad.provincia" :items="provincias"  item-text="provincia" persistent-hint
                                                   return-object
                                                   @change="cambioprovincia"

                                                   label="Departamento"></v-autocomplete>
                              </v-col>
                              <v-col  v-if="negociodisenio.campodistrito"  cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-autocomplete  v-if="negociodisenio.campodistrito"   v-model="editedItem.socioPrincipal.distrito.ciudad" :items="ciudades"  item-text="ciudad" persistent-hint
                                                   return-object
                                                   @change="cambiociudad"
                                                   label="Provincia"
                                  ></v-autocomplete>
                              </v-col>
                              <v-col   v-if="negociodisenio.campodistrito"  cols="12" sm="12" md="5" lg="5" class="ma-0 pa-0 ma-lg-2 ma-md-2 ma-sm-0  pa-sm-0">
                                  <v-autocomplete  v-if="negociodisenio.campodistrito"   v-model="editedItem.socioPrincipal.distrito" :items="distritos"  item-text="distrito" persistent-hint
                                                   return-object
                                                   :label="$t('formularios.EscogerDistrito')"></v-autocomplete>
                              </v-col>

                                          <v-col  v-if="negociodisenio.campofoto"  cols="12" sm="12" md="12">
                                              <v-row class="ma-0 pa-0">
                                                  <v-col v-if="hayimagen" md="12" lg="12" cols="12">

                                                      <v-img :src="imagen2" height="300px" aspect-ratio="1.7" />
                                                  </v-col>
                                                  <v-col md="12" lg="12" cols="12">
                                                      <v-file-input
                                                              label="Subir Foto de Cara, sin lentes de sol o gorra"
                                                              accept="image/*"
                                                              filled
                                                              chips
                                                              v-model="imagen"
                                                              @change="onFileChange"
                                                              prepend-icon="mdi-camera"
                                                      ></v-file-input>
                                                  </v-col>
                                              </v-row>
                                          </v-col>

                                          <v-col cols="12" sm="12" md="12">
                                              <v-checkbox
                                                      v-model="editedItem.aceptoCondicion"
                                                      :rules="[v => !!v || 'Debes aceptar para continuar']"
                                                      :label="negociodisenio.condiciones"
                                                      required
                                              ></v-checkbox>  </v-col>
                                          <v-col  cols="12" sm="12" md="12">
                                              <v-btn v-bind:style="btnPag" v-model="boton"  @click="save">Enviar</v-btn>
                                          </v-col>

                                      </v-row></v-form>
                                  </v-card-text>
                              </v-card>
                </v-col>
              </v-row>
            </section>
          </v-col>
        </v-row>


      </v-container>
    </v-main>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment-timezone";


export default {
  name: "membresia",
  components: {
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Inscripción de socios a "+this.titulonegocio
      }
    ]
    }
  },
  data () {
    return{
      idnegocio: 0,
      overlay:false,
      alertnuevo:false,
      alertnoacepto:false,
      alerterror:false,
      activePicker:null,
      logoexist: false,
      logoimg: null,

        step:1,
      respuesta:'',
      rese:'',
        rules: {
            required: value => !!value || 'Requerido.',
            counter: value => value.length <= 20 || 'Max 20 characters',
            fotomin: value => !value || value.size < 1000000 || 'Tamaño de foto no debe ser mayor a 1 MB!',
            minimo: value => value.length >= 3 || 'Minimo 3 caracteres',
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Mail invalido.'
            },
        },
      browser:false,
      normal:true,
      login:false,
      registro:false,
      boton:false,
        ancho:270,
      menu: false,
      fechamax:null,
      dias:[],
      anios:[],
      aniomax:0,
      aniomin:1950,
      meses:[{
        fec:'01',
        mes:'Enero'
      },{
        fec:'02',
        mes:'Febrero'
      },{
        fec:'03',
        mes:'Marzo'
      },{
        fec:'04',
        mes:'Abril'
      },{
        fec:'05',
        mes:'Mayo'
      },{
        fec:'06',
        mes:'Junio'
      },{
        fec:'07',
        mes:'Julio'
      },{
        fec:'08',
        mes:'Agosto'
      },{
        fec:'09',
        mes:'Septiembre'
      },{
        fec:'10',
        mes:'Octubre'
      },{
        fec:'11',
        mes:'Noviembre'
      },{
        fec:'12',
        mes:'Diciembre'
      }],
      diamax:31,
      diamin:1,
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dni : "",
        foto: "",
        email: "",
        paisNac:{},
        tipoDocumento: {},
        telefono:"",
        direccion:"",
        fechaNacimiento:new Date().toISOString().substr(0, 10),
        sexo:{},
        fotoDni:"",
        postalCode:"",
        distrito:{},
        createdAt:"",
        uidFirebase: "",
        grupoUsuario:{},
        isprofile: true,
        isfoto : false,
        isverified: false
      },
      email: '',
      password:'',
      errorcon: 'Tienes que Aceptar las Condiciones',
      error:'',
      password2:'',
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
     hayimagen: false,
      imagen:'',
      dia:'01',
      mes:'01',
      anio:'1990',
      token:'',
      imagen2:'',
      paises:[],
      provincias:[],
      ciudades:[],
      distritos: [],
      sexos: [{id:0,sexo:"Escoger Sexo"}, {id:1, sexo:"Masculino"}, {id:2, sexo:"Femenino"}],
      tiposdoc: [],
      negocio:[],
      tiposcarnets:[],
      Contactos:[],
      negociodisenio: {
        campoapmaterno: false,
        campodireccion: false,
        campodistrito: false,
        campofecnac: false,
        campofoto: false,
        campoinvitado: false,
        campoizqder: false,
        camporeferido: false,
        camposexo: false,
        campotelefono: false,
        campofumador: false,
        campotipocarnet: false,
        campocontacto: false,
        campocondiciones:false,
        condiciones: '',
          labelApmaterno:'Apellido Materno',
          labelAppaterno:'Apellido Paterno',
          labelNombre:'Nombres'
      },
      editedItem: {
        id:0,
        fecha: new Date(),
        estadoCarnet: {
          id:0,
          estadoCarnet:'',
          color: ''
        },
        formaEnvio: {
          id:0,
          formaEnvio:''
        },
        tipoPago : {
          id:0,
          tipoPago:'',
          visiblePagina:true
        },
        tipoMembresia: {
          id:0,
          tipoMembresia:''
        },
        tipoCarnetSocio:{
          id:0,
          tipoCarnet:'',
          frontal:0,
          temporada:{
            id:0,
            negocio:{
              id:0,
              negocio:'',
              cliente:{
              },
              activo:true,
              icono:'',
              logo:'',
              impuesto:'',
              moneda:{
              },
              tag:'',
              latitud:0,
              longitud:0,
              horaApertura: null,
              horaCierre: null,
              tipoNegocio:{},
              direccion:''
            },
            temporada:'',
            activa:true,
            listas:true,
            inscripcion:true,
            createdAt:null
          },
          activo: true,
          backFront:'',
          backBack:'',
          textColor:'',
          descripcion:'',
          basico:true,
          createdAt:null
        },
        temporada:{},
        contacto:{
          id:0,
          contacto:'SIN CONTACTO'
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal: {
          id:0,
          nombre:'',
          apellidoMaterno:'',
          apellidoPaterno:'',
          dni:'',
          foto:'',
          email:'',
            instagram:'',
          fechaNacimiento: null,
          telefono:'',
          direccion:'',
          sexo:{
            id:0,
            sexo:''
          },
          tipoDocumento:{
            id:0,
            tipoDocumento:''
          },
          paisNac:{
            id:0,
          },
          fotoDni:'',
          postalCode:'',
          distrito:{id:0,
          distrito:'',
          ciudad:{
           id:0,
           ciudad:'',
            provincia:{id:0,
            provincia:'',
            pais:{
              id:0,
              pais:''
            }}
          }},
          createdAt:null,
          uidFirebase:'',
          isprofile:true,
          isfoto: false,
          isverified: false,
          socio:false,
        },
        fechaInicio: null,
        fechaFin: null,
      },
      defaultItem: {
        id:0,
        fecha: new Date(),
        estadoCarnet: {
          id:0,
          estadoCarnet:'',
          color: ''
        },
        formaEnvio: {
          id:0,
          formaEnvio:''
        },
        tipoPago : {
          id:0,
          tipoPago:'',
          visiblePagina:true
        },
        tipoMembresia: {
          id:0,
          tipoMembresia:''
        },
        tipoCarnetSocio:{
          id:0,
          tipoCarnet:'',
          frontal:0,
          temporada:{
            id:0,
            negocio:{
              id:0,
              negocio:'',
              cliente:{
              },
              activo:true,
              icono:'',
              logo:'',
              impuesto:'',
              moneda:{
              },
              tag:'',
              latitud:0,
              longitud:0,
              horaApertura: null,
              horaCierre: null,
              tipoNegocio:{},
              direccion:''
            },
            temporada:'',
            activa:true,
            listas:true,
            inscripcion:true,
            createdAt:null
          },
          activo: true,
          backFront:'',
          backBack:'',
          textColor:'',
          descripcion:'',
          basico:true,
          createdAt:null
        },
        temporada:{},
        contacto:{
          id:0,
          contacto:''
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal: {
          id:0,
          nombre:'',
          apellidoMaterno:'',
          apellidoPaterno:'',
          dni:'',
          foto:'',
          email:'',
          fechaNacimiento: null,
          telefono:'',
          direccion:'',
          sexo:{
            id:0,
            sexo:''
          },
          tipoDocumento:{
            id:0,
            tipoDocumento:''
          },
          paisNac:{
            id:0,
          },
          fotoDni:'',
          postalCode:'',
          distrito:{id:0,
            distrito:'',
            ciudad:{
              id:0,
              ciudad:'',
              provincia:{id:0,
                provincia:'',
                pais:{
                  id:0,
                  pais:''
                }}
            }},
          createdAt:null,
          uidFirebase:'',
          isprofile:false,
          isfoto: false,
          isverified: false,
          socio:false,
        },
        fechaInicio: null,
        fechaFin: null,
      },
      stylePagina: {
        backgroundColor: 'white',
        color:'white',
        backgroundImage:'',
        backgroundSize: 'cover',
      },

      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      }

    }
  }
  ,
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;

    this.damenegocio();
    this.fnBrowserDetect();
    this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
    this.date = this.fechamax
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date);
    for (let i = 1; i<=this.diamax;i++){
      this.dias.push(i.toString().padStart(2,"0"))
    }
    let anchoventana = window.innerWidth

      if(anchoventana>1904){
          this.ancho = 270
      }else{
          if(anchoventana>1264){
              this.ancho=270
          }else{
              if(anchoventana>960){
                  this.ancho=270
              }else{
                  if(anchoventana>600){
                      this.ancho =180
                  }else{
                      this.ancho = 90
                  }
              }
          }
      }

    this.aniomax = moment(this.date).year()
    for (let i = this.aniomin; i<=this.aniomax;i++){
      this.anios.push(i)
    }
    this.anio= this.aniomax
  }
,
watch: {
  date () {
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date)
  },
  menu (val) {
    val && setTimeout(() => (this.activePicker = 'YEAR'))
  },
},

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },

      apaso1(){
        let vald = this.$refs.form1.validate()
          if(vald){
            this.step=2
          }
      },

      apaso2(){
          let vald = this.$refs.form2.validate()
          if(vald){
              if(this.negociodisenio.campodireccion){
                  this.step=3
              }else{
                  if(this.negociodisenio.campofoto){
                      this.step=4
                  }else{
                      this.step=5
                  }

              }


          }
      },
      apaso3(){
          let vald = this.$refs.form3.validate()

          if(vald){
              if(this.negociodisenio.campofoto){
                  this.step=4
              }else{
                  this.step=5
              }

          }
      },
      rpaso4(){
          if(this.negociodisenio.campodireccion){
this.step=3
        }else{
            this.step=2
        }
},
      apaso4(){
          let vald = this.$refs.form4.validate()
          if(vald){
          this.step = 5}
      },
    changemes(){
    if ( this.mes ==="02"){
      this.diamax=29
      this.dias = []
      for (let i = 1; i<=this.diamax;i++){
        this.dias.push(i.toString().padStart(2,"0"))
      }
    }else{
    if(this.mes === "01" || this.mes === "03" || this.mes === "05" || this.mes === "07" || this.mes === "08" || this.mes === "10"  || this.mes === "12" )
    { this.diamax =31
      this.dias = []
      for (let i = 1; i<=this.diamax;i++){
        this.dias.push(i.toString().padStart(2,"0"))
      }
      }else{
      this.diamax = 30
      this.dias = []
      for (let i = 1; i<=this.diamax;i++){
        this.dias.push(i.toString().padStart(2,"0"))
      }
      }
    }
    this.editedItem.socioPrincipal.fechaNacimiento = this.dia.toString().padStart(2, '0')  + '-' + this.mes + '-' + this.anio.toString()
    },
    changeanio(){
      this.editedItem.socioPrincipal.fechaNacimiento =  this.dia.toString().padStart(2, '0')  + '-' + this.mes + '-' + this.anio.toString()

    },
    changedia(){
      this.editedItem.socioPrincipal.fechaNacimiento =  this.dia.toString().padStart(2, '0')  + '-' + this.mes + '-' + this.anio.toString()
    },
    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },

    formatFecha(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    cambiopais(){
      this.dameprovincias()
    },
    cambioprovincia(){
      this.dameciudades()
    },
    cambiociudad(){
      this.damedistritos()
    },
    damepaises(){
      this.progr = true;
      axios
          .get('paises',{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.paises = response.data;
            this.cambiopais();
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameprovincias(){
      this.progr = true;
      axios
          .get('provincias/pais/'+this.editedItem.socioPrincipal.distrito.ciudad.provincia.pais.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.provincias = response.data;
            this.cambioprovincia();

          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameContactos(){
      this.progr = true;
      let urlContacto = 'contactos/negocio/' + this.negocio.id ;
      axios
          .get(urlContacto,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.Contactos = response.data.filter(function (item){
              return item.activo == true
            });
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    dameciudades(){
      this.progr = true;
      axios
          .get('ciudades/provincia/'+this.editedItem.socioPrincipal.distrito.ciudad.provincia.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.ciudades = response.data;
            this.damedistritos()
          })
          .catch((error)  => {
            console.log(error);
          });
    },
      dametipocarnet(){

          axios
              .get('tipocarnets/negocio/membresia/'+this.idnegocio)
              .then(response => {
                  this.editedItem.tipoCarnetSocio = response.data;
                  if(this.editedItem.tipoCarnetSocio.id === null){
                      this.alerterror = true
                      this.error = "EL LINK AL QUE INGRESO NO ES CORRECTO"
                  }else{
                      if(this.editedItem.tipoCarnetSocio.temporada.negocio.id === this.negocio.id){
                          this.alerterror = false
                      }else{
                          this.alerterror = true
                          this.error = "EL LINK AL QUE INGRESO NO ES CORRECTO"
                      }
                  }

              })
              .catch((error)  => {
                  console.log(error);
              });
      },


    dametipodocumentos(){
      this.progr = true;
      axios
          .get('tiposdocumento/pais/'+this.negocio.ciudad.provincia.pais.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tiposdoc = response.data;
            this.editedItem.socioPrincipal.tipoDocumento = this.tiposdoc[0]

          })
          .catch((error)  => {
            console.log(error);
            this.alerterror = true
              this.error = error
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/'+this.editedItem.socioPrincipal.distrito.ciudad.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
              this.alerterror = true
              this.error = error
          });
    },
    damenegocio(){
      this.progr = true;

      axios
          .get('negocios/tag/'+this.idnegocio)
          .then(response => {
            this.negocio = response.data;
              this.dametipocarnet()
              this.dametipodocumentos();
               this.dameContactos();
               this.damedisenio();

          })
          .catch((error)  => {
            console.log(error);
              this.alerterror = true
              this.error = error
          });
    },
    onFileChange(e) {

        const dataURItoBlob = (dataURI) => {
            const bytes = dataURI.split(',')[0].indexOf('base64') >= 0
                ? atob(dataURI.split(',')[1])
                : unescape(dataURI.split(',')[1]);
            const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
            const max = bytes.length;
            const ia = new Uint8Array(max);
            for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i);
            return new Blob([ia], { type: mime });
        };

        const resizeImage = ({ file, maxSize }) => {
            const reader = new FileReader();
            const image = new Image();
            const canvas = document.createElement('canvas');

            const resize = () => {
                let { width, height } = image;

                if (width > height) {
                    if (width > maxSize) {
                        height *= maxSize / width;
                        width = maxSize;
                    }
                } else if (height > maxSize) {
                    width *= maxSize / height;
                    height = maxSize;
                }

                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(image, 0, 0, width, height);

                const dataUrl = canvas.toDataURL('image/jpeg');

                return dataURItoBlob(dataUrl);
            };

            return new Promise((ok, no) => {
                if (!file.type.match(/image.*/)) {
                    no(new Error('Not an image'));
                    return;
                }

                reader.onload = (readerEvent) => {
                    image.onload = () => ok(resize());
                    image.src = readerEvent.target.result;
                };

                reader.readAsDataURL(file);
            });
        };
        resizeImage({ file: this.imagen, maxSize: 1024 }).then((resizedImage) => {
            this.imagen2 = URL.createObjectURL(resizedImage);
            this.hayimagen = true
            var bodyFormData = new FormData();
            bodyFormData.append("file",resizedImage);
            let url = "personas/fotodni/" + this.editedItem.socioPrincipal.dni
            this.overlay = true
            axios
                .post(url,bodyFormData,{
                    headers: {
                        'Authorization': `Bearer ${this.token}`,
                    }
                })
                .then(response => {
                    this.alerteditar = true
                    this.editedItem.socioPrincipal.foto = response.data
                    this.overlay = false
                })
                .catch(error => {
                    this.error = error;
                    this.overlay = false;
                    this.alertnoacepto = true
                    this.errorcon = "Foto es muy grande, cambiela a una menor 1 mega"
                    this.imagen2= ''
                    this.hayimagen = false
                    console.log(error);
                });
        }).catch((err) => {
            console.error(err);
        });

      console.log(e)
    },
    save () {

      if(this.negociodisenio.campofoto){
      if(this.editedItem.socioPrincipal.foto.length>2 ){
       this.revisareferido();
      }else{
        this.alertnoacepto = true
        this.errorcon = "Debe subir una foto"
      }
      }else{
        this.revisareferido();
      }

    },
    revisareferido(){
      if(this.negociodisenio.camporeferido){
        if(this.editedItem.referido.length>2 ){
          this.editedItem.contacto = {
            id:0,
            activo:true,
            contacto: this.editedItem.referido,
            negocio: {}
          }
          this.basicos();
        }else{
          this.alertnoacepto = true
          this.errorcon = "Debe Agregar un Referido"
        }
      }else{
          this.revisacontacto();
      }
    },
    revisacontacto(){
      if(this.negociodisenio.campocontacto){
        if(this.editedItem.contacto.id>0 ){
          this.basicos();
        }else{
          this.alertnoacepto = true
          this.errorcon = "Debe Escoger un Contacto"
        }
      }else{
        this.basicos();
      }
    },
    basicos(){
      if(this.editedItem.socioPrincipal.apellidoPaterno.length>2){
        if(this.editedItem.socioPrincipal.nombre.length>2){
          if(this.editedItem.socioPrincipal.dni.length>7){

              if(this.editedItem.aceptoCondicion)
              {
                this.grabar();
              }else{
                this.alertnoacepto =true
                this.errorcon = "Tienes que Aceptar las Condiciones"
              }
          }else{
            this.alertnoacepto =true
            this.errorcon = "Debe Ingresar un documento correcto "
          }}else{
          this.alertnoacepto =true
          this.errorcon = "Debe Ingresar un nombre correcto"
        }}else{
        this.alertnoacepto =true
        this.errorcon = "Debe Ingresar un apellido correcto"
      }
    },
    grabar(){
      this.overlay = true;



      var bodyFormData2 = new FormData();

      if (this.editedItem.socioPrincipal.fechaNacimiento === "Fecha inválida"){
        this.editedItem.socioPrincipal.fechaNacimiento = null;
      }else{
          this.editedItem.socioPrincipal.fechaNacimiento = this.dia+'-'+this.mes+'-'+this.anio
      }

      this.editedItem.socioPrincipal.email = this.editedItem.socioPrincipal.email.toLowerCase().trim();
      bodyFormData2.append("persona",JSON.stringify(this.editedItem.socioPrincipal));
      bodyFormData2.append("tipoCarnetId",this.editedItem.tipoCarnetSocio.id);
      bodyFormData2.append("contacto",JSON.stringify(this.editedItem.contacto));
      bodyFormData2.append("referido",this.editedItem.referido);
      bodyFormData2.append("condicion",this.negociodisenio.condiciones);


      axios
          .post('membresia/crear',bodyFormData2).then(response => {
        let usuariodto = response.data
        this.respuesta = usuariodto.respuesta
        this.editedItem = this.defaultItem
        this.alertnuevo = true;
        this.overlay = false;
        this.step = 1;
        this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
        this.date = this.fechamax
        this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date);
        for (let i = 1; i<=this.diamax;i++){
          this.dias.push(i)
        }

        this.aniomax = moment(this.date).year()
        for (let i = this.aniomin; i<=this.aniomax;i++){
          this.anios.push(i)
        }
        this.anio= this.aniomax
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.alerterror = true
            console.log(error);
            this.overlay = false;
          });

    },

      damexemail(){

          var bodyFormData2 = new FormData();
          bodyFormData2.append("email",this.editedItem.socioPrincipal.email);
          axios
              .post('personas/email',bodyFormData2).then(response => {
                  if(response.data.email === this.editedItem.socioPrincipal.email){
                      this.editedItem.socioPrincipal = response.data
                      let fechanc =  new Date(response.data.fechaNacimiento+'T12:00:00')
                      this.dia = fechanc.getDate().toString().padStart(2,"0")
                      let elmes =   fechanc.getMonth() + 1
                      this.mes = elmes.toString().padStart(2,"0")
                      this.anio = fechanc.getFullYear()
                  }

          })
              .catch(error => {
                  this.error = "Hubo un error";
                  this.alerterror = true
                  console.log(error);
                  this.overlay = false;
              });
      },

    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },

    formatfechanac(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    cambiaCheck(){
      if(this.editedItem.aceptoCondicion){
       this.boton = true
      }else{
        this.boton = false
      }
    },
    damedisenio(){
      this.progr = true;
      var bodyFormData = new FormData();
      bodyFormData.append('hasp', this.idnegocio);
      axios
          .get('negociodisenio/membresia/'+ this.idnegocio)
          .then(response => {
            this.negociodisenio = response.data;

            if (this.negociodisenio.negocio.logo270 === null){
                this.logoexist = false;
            }else{
              this.logoexist  = true;
              this.logoimg = this.negociodisenio.negocio.logo270;
            }
            if (this.negociodisenio.condiciones !== '' && this.negociodisenio.condiciones !== null){
              this.campocondiciones = true
              this.condiciones = this.negociodisenio.condiciones
              this.editedItem.condicionAceptada = this.condiciones
            }

            this.titulonegocio = this.negociodisenio.negocio.negocio;
            let objPag= {
              backgroundColor: this.negociodisenio.backgroundColor,
              color:this.negociodisenio.colorText,
              backgroundImage:'url(' + this.negociodisenio.backgroundImage + ')',
                backgroundSize:'cover'
            }
            let btnPag= {
              backgroundColor: this.negociodisenio.colorBgBoton,
              color:this.negociodisenio.colorTxtBoton
            }
            this.btnPag = btnPag
            this.stylePagina = objPag
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>
